import React, { FC } from "react";
import { ToastService } from "../services";
import { CustomLabel, FlexContainer, MadisonBlueButton } from "../styles";

interface NavigationButtonsProps {
  currentIndex: number;
  totalItems: number;
  previousRecordId: string | null;
  nextRecordId: string | null;
  onNavigate: (newRecordId: string) => void;
}

const NavigationButtons: FC<NavigationButtonsProps> = ({
  currentIndex,
  totalItems,
  previousRecordId,
  nextRecordId,
  onNavigate,
}) => {
  const handleNavigation = (direction: 'back' | 'next') => {
      const newRecordId = direction === 'next' ? nextRecordId : previousRecordId;
      if (newRecordId) {
          onNavigate(newRecordId);
      } else {
          ToastService.showError('No more records in this direction.');
      }
  };

  return totalItems > 0 ? (
      <FlexContainer alignItems="center" spacing={10} justifyContent="flex-end" margin="0px 20px 0px">
          <MadisonBlueButton
              onClick={() => handleNavigation('back')}
              disabled={previousRecordId === ''}
              minWidth={''}
              lineHeight="inherit"
              padding="0px 15px"
          >
              Back
          </MadisonBlueButton>
          <CustomLabel fontSize={'20px'}>{`${currentIndex} of ${totalItems}`}</CustomLabel>
          <MadisonBlueButton
              onClick={() => handleNavigation('next')}
              disabled={nextRecordId === ''}
              minWidth={''}
              lineHeight="inherit"
              padding="0px 15px"
          >
              Next
          </MadisonBlueButton>
      </FlexContainer>
  ) : (
      <></>
  );
};

export default NavigationButtons;
